import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectCurrentContent,
  selectCurrentEntity,
  selectIsPlaying,
} from "../redux/selectors/playerSelector";
import { togglePlayer } from "../redux/Slice/playerSlice";
import { useTrackNavigation } from "./useTrackNavigation";

export const useMediaSession = (playerRef) => {
  const dispatch = useDispatch();

  const currentEntity = useSelector(selectCurrentEntity);
  const isRelease = currentEntity === "release";

  const currentContent = useSelector(selectCurrentContent);
  const isPlaying = useSelector(selectIsPlaying);

  const { handleSkip } = useTrackNavigation();

  useEffect(() => {
    if (!currentContent || !("mediaSession" in navigator)) return;

    if (isRelease) {
      // Обработка подкастов
      navigator.mediaSession.metadata = new MediaMetadata({
        title: currentContent.title,
        artist: currentContent.podcastTitle,
        album: "",
        artwork: [
          {
            src: currentContent.cover.big,
            sizes: "512x512",
          },
          {
            src: currentContent.cover.small,
            sizes: "256x256",
          },
        ],
      });
    } else {
      // Обработка песен
      navigator.mediaSession.metadata = new MediaMetadata({
        title: currentContent.track,
        artist: currentContent.artist,
        album: currentContent.album,
        artwork: [
          {
            src: currentContent.cover.big,
            sizes: "512x512",
          },
          {
            src: currentContent.cover.small,
            sizes: "256x256",
          },
        ],
      });
    }

    if (isRelease) {
      navigator.mediaSession.setActionHandler("previoustrack", () => {
        handleSkip(-1);
      });
      navigator.mediaSession.setActionHandler("nexttrack", () => {
        handleSkip(1);
      });

      navigator.mediaSession.setActionHandler("seekto", (details) => {
        if (!playerRef.current) return;

        playerRef.current.seekTo(details.seekTime, "seconds");
      });
    }

    navigator.mediaSession.setActionHandler("play", () => {
      dispatch(togglePlayer());
    });

    navigator.mediaSession.setActionHandler("pause", () => {
      dispatch(togglePlayer());
    });

    navigator.mediaSession.playbackState = isPlaying ? "playing" : "paused";

    return () => {
      navigator.mediaSession.setActionHandler("play", null);
      navigator.mediaSession.setActionHandler("pause", null);
      navigator.mediaSession.setActionHandler("previoustrack", null);
      navigator.mediaSession.setActionHandler("nexttrack", null);
      navigator.mediaSession.setActionHandler("seekto", null);
    };
  }, [currentContent, dispatch, handleSkip, isPlaying, isRelease, playerRef]);
};
